import React, { useContext } from 'react';
import * as pluralize from 'pluralize';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCardTitle,
  CFormGroup,
  CSwitch,
} from '@coreui/react';
import { useFormikContext } from 'formik';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';

const BulkAgentsRemovalForm = () => {
  const labels = useContext(ConfigContext);
  const formik = useFormikContext();

  return (
    <CCard className="glympser-container--roundedWithShadow">
      <CCardHeader className="glympser-roundedTop">
        <div className="d-flex align-items-center justify-content-between">
          <CCardTitle className="m-0">
            Mass-delete {pluralize(labels.agent)}
          </CCardTitle>
        </div>
      </CCardHeader>
      <CCardBody>
        <CFormGroup>
          <div className="d-flex align-items-center">
            Enable:
            <CSwitch
              type="checkbox"
              className="ml-1"
              {...formik.getFieldProps({
                name: 'bulkAgentsRemoveEnabled',
                type: 'checkbox',
              })}
            />
          </div>
        </CFormGroup>
      </CCardBody>
    </CCard>
  );
};

export default BulkAgentsRemovalForm;
